import {get} from '@/lib/utils/env';
import utils from '@/lib/utils';
import {AxiosPromise} from 'axios';

const {SITE_TYPE} = get();

export const getShippingRelayCosts = (): AxiosPromise<ShippingRelayCosts> => {
  return utils.axios.api().get(`/v1/${SITE_TYPE}/shipping_relay_costs`);
};
